import React from 'react';
import PropTypes from 'prop-types';
import makeClassName from 'shared-utils/src/makeClassName/index';
import NoAlarmIcon from 'shared-vectors/icons/BellFilledOff';
import Close from 'shared-vectors/icons/DsClose';
import { Icon } from 'shared-vectors';
import Grid from 'shared-components/components/Grid';
import GridItem from 'shared-components/components/GridItem';

import './critical.scss';

const HintTooltip = ({
  visible:
  vis,
  title,
  subTitle,
  hideTooltip,
  isMCFakeTooltip = false,
  isMobile = true,
}) => {
  const mainCls = 'hint-tooltip-save-search-btn';

  const toolTipCls = makeClassName([
    mainCls,
    isMCFakeTooltip ? 'mcfake' : '',
    `b--m c-bg--${isMCFakeTooltip ? 'warn' : 'succbg'} c-br--${isMCFakeTooltip ? 'err' : 'succbr'} b-r--ds`, 
    vis && `${mainCls}__visible`,
  ]);
  const ctn = isMCFakeTooltip
    ? (
      <>
        <GridItem behavior="fixed" className={`${mainCls}__bell mr--s c-txt--borderdark`}>
          <Icon
            name={NoAlarmIcon}
            width="100%"
            fill
          />
        </GridItem>
        <GridItem className="tp-w--s tp-s--l c-txt--f0">
          <span className="tp-w--l">Attiva la ricerca</span> per ricevere le notifiche dei nuovi annunci
        </GridItem>
      </>
    ) : (
      <GridItem className="tp-w--s tp-s--m c-txt--f0">
        <span className="tp-w--l tp-s--l">{title}</span> {subTitle}
      </GridItem>
    );
  return (
    <Grid className={toolTipCls} align="center" justify="center">
      <Grid
        align={isMobile ? 'start' : 'center'}
        justify="space-between"
        className={`${mainCls}__header p--m`}
        noWrap
      >
        {ctn}
        <GridItem
          behavior="fixed"
          onClick={() => hideTooltip({ position: 'CloseButton' })}
          className={`${mainCls}__header_cnt ml--s c-txt--f${isMCFakeTooltip ? '5' : '0'} is-clickable`}
        >
          <Icon
            name={Close}
            size="m"
            fill
          />
        </GridItem>
      </Grid>
    </Grid>
  );
};

export default HintTooltip;

HintTooltip.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  hideTooltip: PropTypes.func,
  isMCFakeTooltip: PropTypes.bool,
  isMobile: PropTypes.bool,
};

HintTooltip.defaultProps = {
  visible: false,
  title: '',
  subTitle: '',
  hideTooltip: () => { },
  isMCFakeTooltip: false,
  isMobile: true,
};
